import Link from "next/link";

export default function Cta() {
  return (
    <section className="overflow-hidden relative hidden md:block max-w-screen w-screen pt-24 bg-center font-['Inter'] h-[64rem] sm:h-[48rem] lg:h-[32rem] left-0 right-0">
    <div className="bg-[#F7F8F9] max-w-screen w-screen absolute left-0">
      <div className="flex flex-col justify-center items-center pt-16 px-16 xl:max-w-4xl lg:max-w-4xl md:max-w-3xl mx-auto text-center">
        <h2 className="mb-4 text-3xl md:text-4xl font-heading font-bold text-maingray">
        We are the CKAN experts
        </h2>
        <p className="mb-10 text-lg md:text-xl font-heading font-['Inter'] font-normal text-secgray ">
        Looking to maximize your data potential? Experience the power of our custom-built open-source solutions. We create, maintain, and deploy data management and data engineering technologies using CKAN, Frictionless Data, DataHub.io and other open-source software that we have built ourselves. We&apos;re the trusted partner for government, enterprise, and non-profit organizations.
        </p>
        
      </div>
      <div className="flex flex-col items-center md:flex-row justify-center pb-16 md:px-16 px-4 gap-4">
          <Link
            href="/contact"
            className="btn-primary"
          >
            Get Started with a Free Consultation
          </Link>
        </div>
    </div>
  </section>
  )
}
